import React from 'react';

import { cn } from '~/lib/utils';

import { SEARCH_BAR_STYLES } from '../constants';

interface ClearButtonProps {
  onClear: () => void;
  disabled?: boolean;
  className?: string;
}

export const ClearButton: React.FC<ClearButtonProps> = ({
  onClear,
  disabled = false,
  className
}) => {
  return (
    <button
      type="button"
      onClick={onClear}
      disabled={disabled}
      className={cn(
        SEARCH_BAR_STYLES.CLEAR_BUTTON,
        disabled && 'opacity-50 cursor-not-allowed',
        className
      )}
      aria-label="Clear search">
      ✕
    </button>
  );
};
